import React, { createContext, useContext, useState, useEffect } from 'react';
import keycloakService from '../services/keycloak';
import { useNavigate, useLocation } from 'react-router-dom';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('AuthProvider: Initializing...'); // Debug log
    const initAuth = async () => {
      try {
        console.log('AuthProvider: Initializing Keycloak...'); // Debug log
        const isAuthenticated = await keycloakService.init();
        console.log('AuthProvider: Keycloak initialized, authenticated:', isAuthenticated); // Debug log
        
        setAuthenticated(isAuthenticated);
        if (isAuthenticated) {
          const roles = keycloakService.getRoles();
          console.log('AuthProvider: User roles:', roles); // Debug log
          setUser({
            username: keycloakService.getUsername(),
            roles: roles
          });
          
          // Only redirect if we're on the login page
          if (location.pathname === '/login') {
            navigate('/', { replace: true });
          }
        }
      } catch (error) {
        console.error('AuthProvider: Initialization error:', error);
        setAuthenticated(false);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, [navigate, location]);

  const login = () => {
    console.log('AuthProvider: Initiating login...'); // Debug log
    keycloakService.login();
  };

  const logout = () => {
    console.log('AuthProvider: Initiating logout...'); // Debug log
    keycloakService.logout();
    setAuthenticated(false);
    setUser(null);
    navigate('/login', { replace: true });
  };

  const hasRole = (role) => {
    const hasRole = keycloakService.hasRole(role);
    console.log('AuthProvider: Checking role', role, 'Result:', hasRole); // Debug log
    return hasRole;
  };

  const value = {
    authenticated,
    loading,
    user,
    login,
    logout,
    hasRole
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}; 